import { combineReducers } from 'redux';

import createReducer from 'redux/lib/reducerConfig';
import { reportError } from 'utils/reporting';
import { TagsService } from '../../types';

const initialState = [];

const ActionTypes = {
  SET_TAGS: 'SET_TAGS',
};

function setTags(tags) {
  return {
    type: ActionTypes.SET_TAGS,
    payload: tags,
  };
}

export const fetchTags = () => async (dispatch) => {
  try {
    const { rows: tags } = await TagsService.getTagList({
      ignorePagination: true,
    });
    dispatch(setTags(tags));
  } catch (err) {
    reportError(err);
  }
};

const reducer = createReducer(
  initialState,
  {
    [ActionTypes.SET_TAGS]: (state, action) => {
      return action.payload;
    },
  }
);

export const tagsReducer = combineReducers({
  tags: reducer,
});
